import React from 'react';

const Menu = () => {
  return (
    <div>
      <section className="section section-bg" id="call-to-action" style={{ backgroundImage: "url(assets/images/vvipgals.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cta-content">
                <br />
                <br />
                <h2>We Offer <em>Coffee and Cocktails</em></h2>
                <p>Our best selling Products made with 🥰</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="trainers">
        <div className="container">
          <br />
          <br />

          <div className="row">
            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/8.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/5.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/4.jpg" alt="" />
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/3.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/2.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="trainer-item">
                <div className="image-thumb">
                  <img src="assets/images/products/1.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>

          <br />

        </div>
      </section>
    </div>
  )
};

export default Menu;